// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._29F7V{color:#6f7ea3;position:relative}._29F7V hr{margin:16px 0}._29F7V .page{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:.5in .25in;width:8in;-ms-flex-pack:justify;color:#6f7ea3;justify-content:space-between}@media print{._29F7V .page{margin:0 .25in}}._29F7V .page .page{width:100%}._29F7V .page *{font-family:Arial,sans-serif}._29F7V .pagination-pages{width:100%}._29F7V ._1UGzD{padding:4px}.UiL5X{left:30px;left:3rem;position:fixed;top:30px;top:3rem}", ""]);
// Exports
exports.locals = {
	"patientsBgDataReport": "_29F7V",
	"table__cell": "_1UGzD",
	"exportToCsv": "UiL5X"
};
module.exports = exports;
